var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, observable, InternalMessageBusChannels } from "../ExternalDependencies";
import { EventResult, LoadState, LeagueResult } from "../data";
export class Parser {
    constructor(retriever, internalMessageBus, dict, navHandler, dateTimeData, config) {
        this.loadState = LoadState.NotLoading;
        this.personalizedLoadState = LoadState.NotLoading;
        this.searchResults = [];
        this.personalizedResults = [];
        this.recents = [];
        this.searchResultMapper = (entity) => this.createResult(entity, entity.entityType);
        this.createEventResult = (event) => new EventResult(event, this.openGameHandler, this.dateTimeData, this.dict);
        this.createLeagueResult = (league) => new LeagueResult(league, this.openLeagueHandler);
        this.createResult = (entity, type) => {
            return type === "Event" ? this.createEventResult(entity) : this.createLeagueResult(entity);
        };
        this.updateEvents = (result) => this.processRecentsUpdate(result.events, "Event");
        this.updateLeagues = (result) => {
            const leagues = result.leagues.filter(league => league.fixturesTotalCount > 0);
            this.processRecentsUpdate(leagues, "League");
        };
        this.processRecentsUpdate = (entities, type) => {
            entities.forEach(entity => {
                const recent = this.recents.find(recent => recent.type === type && recent.id === entity.id);
                if (recent) {
                    recent.entity = this.createResult(entity, type);
                }
            });
            this.recents = this.recents.filter(recent => recent.type !== type || recent.entity);
        };
        this.retriever = retriever;
        this.internalMessageBus = internalMessageBus;
        this.dict = dict;
        this.navHandler = navHandler;
        this.dateTimeData = dateTimeData;
        this.config = config;
        this.timeZoneChangeHandler = this.timeZoneChangeHandler.bind(this);
        this.getRecents = this.getRecents.bind(this);
        this.saveRecents = this.saveRecents.bind(this);
        this.openGameHandler = this.openGameHandler.bind(this);
        this.openLeagueHandler = this.openLeagueHandler.bind(this);
    }
    activate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.internalMessageBus.on(InternalMessageBusChannels.legacy.timeZone.update, this.timeZoneChangeHandler, this);
            const tasks = [];
            this.config.IsRecentResultsEnabled && tasks.push(this.getRecents());
            this.config.IsRecommendedEventsEnabled && tasks.push(this.getPersonalizedData());
            yield Promise.all(tasks);
        });
    }
    deactivate() {
        this.internalMessageBus.off(InternalMessageBusChannels.legacy.timeZone.update, this.timeZoneChangeHandler, this);
    }
    getData(query) {
        return __awaiter(this, void 0, void 0, function* () {
            this.loadState = LoadState.Loading;
            try {
                const searchResults = yield this.retriever.getData(query);
                this.searchResults = searchResults.map(this.searchResultMapper);
            }
            catch (_a) {
                this.searchResults = [];
            }
            finally {
                this.loadState = LoadState.Loaded;
            }
        });
    }
    getPersonalizedData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.personalizedLoadState = LoadState.Loading;
            try {
                const response = yield this.retriever.getPersonalizedData();
                this.personalizedResults = response.events.map(this.createEventResult);
            }
            catch (_a) { }
            finally {
                this.personalizedLoadState = LoadState.Loaded;
            }
        });
    }
    addToRecents(item) {
        if (!this.config.IsRecentResultsEnabled) {
            return;
        }
        const existingItem = this.recents.find(recent => recent.id === item.id && recent.type === item.entityType);
        if (existingItem) {
            existingItem.timestamp = Date.now();
        }
        else {
            this.recents.push({
                type: item.entityType,
                id: item.id,
                sportId: item.sportId,
                timestamp: Date.now(),
                entity: item
            });
        }
        if (this.recents.length > this.config.MaxRecentsCount) {
            this.recents = this.recents.slice().sort((a, b) => b.timestamp - a.timestamp).slice(0, this.config.MaxRecentsCount);
        }
        this.saveRecents();
    }
    updateRecents() {
        return __awaiter(this, void 0, void 0, function* () {
            const requests = [];
            const eventIds = this.recents.filter(item => item.type === "Event").map(item => item.id);
            if (eventIds.length > 0) {
                requests.push(this.retriever.getEvents(eventIds).then(this.updateEvents).catch(() => { }));
            }
            const leagueIds = this.recents.filter(item => item.type === "League").map(item => item.id);
            if (leagueIds.length > 0) {
                requests.push(this.retriever.getLeagues(leagueIds).then(this.updateLeagues).catch(() => { }));
            }
            yield Promise.all(requests);
        });
    }
    clearRecents() {
        this.recents = [];
        this.saveRecents();
    }
    getRecents() {
        return __awaiter(this, void 0, void 0, function* () {
            const recents = this.retriever.getRecents();
            this.recents = recents.filter(recent => this.retriever.orderedSportIds.includes(recent.sportId));
            yield this.updateRecents();
        });
    }
    saveRecents() {
        this.retriever.saveRecents(this.recents);
    }
    openGameHandler(event, item) {
        this.addToRecents(item);
        this.navHandler.OpenGame(event, Number(item.id), item.isLive, Number(item.isLive), false, Number(item.sportId));
    }
    openLeagueHandler(event, item) {
        this.addToRecents(item);
        this.navHandler.OpenLeague(event, item.id, item.sportId);
    }
    timeZoneChangeHandler(message) {
        this.dateTimeData.timeZone = message.data[0].currentSelectedTimeZone;
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], Parser.prototype, "loadState", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Parser.prototype, "personalizedLoadState", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "searchResults", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "personalizedResults", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "recents", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], Parser.prototype, "getData", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Parser.prototype, "getPersonalizedData", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "addToRecents", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Parser.prototype, "updateRecents", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "clearRecents", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Parser.prototype, "getRecents", null);
//# sourceMappingURL=Parser.js.map